import { http, HttpResponse } from 'msw'

export const mockDeleteCustomerCard = http.delete(
  '/my-business/api/agency/v1/customers/:customerId/cards/:cardId',
  () =>
    HttpResponse.json({ timestamp: new Date().toISOString() }, { status: 200 }),
)
